(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('product-list-tabs')) return;

    class ProductListTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.#selectTab(tab));
          tab.addEventListener('keydown', (event) => this.#onKeydown(event, tab));
        });
      }

      #selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          const isMatch = panel.id === selectedTab.getAttribute('aria-controls');
          panel.toggleAttribute('hidden', !isMatch);
        });
      }

      #onKeydown(event, currentTab) {
        const currentIndex = this.tabs.indexOf(currentTab);
        let newIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          newIndex = (currentIndex + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          newIndex = 0;
        } else if (event.key === 'End') {
          newIndex = this.tabs.length - 1;
        }

        if (newIndex !== null) {
          event.preventDefault();
          const newTab = this.tabs[newIndex];
          newTab.focus();
          this.#selectTab(newTab);
        }
      }
    }

    customElements.define('product-list-tabs', ProductListTabs);
  })();

  } catch(e) { console.error(e); }
})();
})();
